module.exports = __webpack_public_path__ + "img/fase-fenologica.b77724f7.svg";